import { ColorsHelper } from '@/utils/ColorsHelper';
import { FC, PropsWithChildren, useEffect } from 'react';
import { Toaster } from 'sonner';

const AuthorizationLayout: FC<PropsWithChildren> = ({ children }) => {
	useEffect(() => {
		ColorsHelper.setDefaultColor();
	}, []);

	return (
		<div className='min-h-svh flex'>
			<main className='flex-1 flex justify-center bg-popover-10'>
				{children}
				<Toaster />
			</main>
		</div>
	);
};

export default AuthorizationLayout;
